import React from 'react'
import { useInView } from 'react-intersection-observer'

import * as style from './style.module.sass'

type BlurContainerProps = {
  children: React.ReactNode
  threshold?: number
}

const BlurContainer: React.FC<BlurContainerProps> = ({
  children,
  threshold = 0.5,
}) => {
  const { ref, inView } = useInView({
    threshold,
    triggerOnce: true,
  })

  return (
    <div ref={ref} className={style.blur} data-in-view={inView}>
      {children}
    </div>
  )
}

export default BlurContainer
